import { ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-collapsible',
  templateUrl: './collapsible.component.html',
  styleUrls: ['./collapsible.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollapsibleComponent {
  @Input() title!: string;
  @Input() content!: string;
  @Input() open = false;

  constructor(private elementRef: ElementRef) {}

  public toggle(): void {
    this.open = !this.open;

    const $target = $(this.elementRef.nativeElement);
    const $content = $target.find('.js-accordion-item-content');

    $content.stop().toggle(300);
  }
}
